import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connectSearchBox } from 'react-instantsearch-dom'

import { Input, TransparentButton, inputIconWidth } from '@redriverpress/system'

const SearchInput = styled(Input).attrs(props => ({
  type: 'search',
  icon: 'search',
  iconRight: props.withCancelButton && props.value ? 'times' : '',
  label: 'Search for…',
  placeholder: props.placeholder,
}))`
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-decoration {
    appearance: none;
  }
`

// Extension of Algolia's Search Box component
// https://www.algolia.com/doc/api-reference/widgets/search-box/react/
function SearchBox({
  currentRefinement,
  placeholder,
  refine,
  withCancelButton,
}) {
  return (
    <form
      noValidate
      action=''
      role='search'
      onSubmit={e => e.preventDefault()}
      style={{ position: 'relative' }}
    >
      <SearchInput
        placeholder={placeholder}
        onChange={e => refine(e.currentTarget.value)}
        value={currentRefinement}
        withCancelButton={withCancelButton}
      />
      {withCancelButton && currentRefinement && (
        <TransparentButton
          position='absolute'
          right={0}
          top={0}
          height='100%'
          width={inputIconWidth}
          zIndex={1}
          type='reset'
          title='Clear search query'
          onClick={() => refine('')}
        />
      )}
    </form>
  )
}

SearchBox.defaultProps = {
  withCancelButton: false,
}

SearchBox.propTypes = {
  currentRefinement: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  refine: PropTypes.func.isRequired,
  withCancelButton: PropTypes.bool,
}

export default connectSearchBox(SearchBox)
